import { useT } from '../i18n';

export default function MeetLisa() {
  const t = useT();
  return (
    <section className="section" style={{ paddingTop: 160, minHeight: '70vh', display: 'flex', alignItems: 'center' }}>
      <div className="container" style={{ textAlign: 'center' }}>
        <img src="/assets/img/lisa-avatar.svg" alt="LISA" style={{ width: 180, height: 180, borderRadius: '50%', margin: '0 auto', boxShadow: 'var(--shadow-glow)' }} />
        <h1 style={{ marginTop: 24 }}>{t('lisa.name')}</h1>
        <p className="body-lg" style={{ maxWidth: 520, margin: '16px auto' }}>
          {t('lisa.disclosure_banner')}
        </p>
        <button className="btn btn-primary btn-lg" type="button" data-open-lisa>
          {t('lisa.fab_aria')}
        </button>
      </div>
    </section>
  );
}
